﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartVaultContract = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const SmartVaultABI_1 = require("./abi/SmartVaultABI");
const SmartVaultManagerContract_1 = require("./SmartVaultManagerContract");
class SmartVaultContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, SmartVaultABI_1.SmartVaultABI.GetABI());
        this._info = new SmartVaultManagerContract_1.SmartVaultInfo();
        this._info.addrs = address;
    }
    refreshInfo(info) {
        this._info = info;
    }
    getInfo() { return this._info; }
    borrowAsync(valueETH, maxMainFeeIndexETH, minLoanValueETH) {
        return __awaiter(this, void 0, void 0, function* () {
            const valueWEI = this._toWei(valueETH);
            const maxMainFeeIndexWEI = this._toWei(maxMainFeeIndexETH);
            const minLoanValueWEI = this._toWei(minLoanValueETH);
            const result = yield this._pay(valueWEI, "borrow", maxMainFeeIndexWEI, minLoanValueWEI);
            return result;
        });
    }
    repayDebtAsync(usdlAmountETH, minCollValueETH) {
        return __awaiter(this, void 0, void 0, function* () {
            const usdlAmountWEI = this._toWei(usdlAmountETH);
            const minCollValueWEI = this._toWei(minCollValueETH);
            const result = yield this._send("repayDebt", usdlAmountWEI, minCollValueWEI);
            return result;
        });
    }
    tokenizeAsync(usdlLoanToPLSVETH, minTokenizePLSVETH) {
        return __awaiter(this, void 0, void 0, function* () {
            const usdlLoanToPLSVWei = this._toWei(usdlLoanToPLSVETH);
            const minTokenizePLSVWei = this._toWei(minTokenizePLSVETH);
            const result = yield this._send("tokenize", usdlLoanToPLSVWei, minTokenizePLSVWei);
            return result;
        });
    }
    detokenizeAsync(plsvETH, minDetokenizeLoanETH, minDetokenizeCollETH) {
        return __awaiter(this, void 0, void 0, function* () {
            const plsvWei = this._toWei(plsvETH);
            const minDetokenizeLoanWei = this._toWei(minDetokenizeLoanETH);
            const minDetokenizeCollWei = this._toWei(minDetokenizeCollETH);
            const result = yield this._send("detokenize", plsvWei, minDetokenizeLoanWei, minDetokenizeCollWei);
            return result;
        });
    }
    checkMainVaultChangesAsync() {
        return __awaiter(this, void 0, void 0, function* () { const result = yield this._send("checkMainVaultChanges"); return result; });
    }
    repayNeedRepayMainDebtAsync() {
        return __awaiter(this, void 0, void 0, function* () { const result = yield this._send("repayNeedRepayMainDebt"); return result; });
    }
    claimMainCollateralAsync() {
        return __awaiter(this, void 0, void 0, function* () { const result = yield this._send("claimMainCollateral"); return result; });
    }
    claimCollateralAsync() {
        return __awaiter(this, void 0, void 0, function* () { const result = yield this._send("claimCollateral"); return result; });
    }
    getVaultsOwnersCount() {
        return __awaiter(this, void 0, void 0, function* () { const count = yield this._call("getVaultsOwnersCount"); return parseInt(count); });
    }
    getDebtColl(forAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const info = yield this._call("getDebtColl", forAddress);
            return { debt: this._toDecimal(info.debt), coll: this._toDecimal(info.coll) };
        });
    }
    getVault(forAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const vault = yield this._call("Vault", forAddress);
            return { debt: this._toDecimal(vault.debt), coll: this._toDecimal(vault.coll), arrayIndex: parseInt(vault.arrayIndex) };
        });
    }
}
exports.SmartVaultContract = SmartVaultContract;
//# sourceMappingURL=SmartVaultContract.js.map